import S from 's-js';
import { AssertExtends } from 'lib/assertExtends';

import { PortCall } from 'data/models/PortCall';

import { PCCache } from 'data/PCCache';

import { PortCallScheduleHeader } from 'portcall/portcallschedule/header';
import {
    CoordinationSelectionStorageFactory,
    ScheduleDateCoordinationSelectionStorageParams,
    SelectCoordinations,
    SelectCoordinationsParams,
} from 'portcall/selectcoordinations/model';

import { AddPortCallTabModel } from './model';

export interface AddPortCallCoordinationsTabParams {
    PortCall : PortCall;
    ScheduleHeader : PortCallScheduleHeader;
}

export type AddPortCallCoordinationsTab = AssertExtends<ReturnType<typeof AddPortCallCoordinationsTab>, AddPortCallTabModel>;
export function AddPortCallCoordinationsTab(
    data : PCCache,
    schedDateCoordSelStorage : (params : ScheduleDateCoordinationSelectionStorageParams) => CoordinationSelectionStorageFactory,
    selectCoordinationsModel : (params : SelectCoordinationsParams) => SelectCoordinations,
    {
        PortCall,
        ScheduleHeader
    } : AddPortCallCoordinationsTabParams
) {
    const
        SelectCoordinations = selectCoordinationsModel({
            PortCall,
            SelectionStorage: schedDateCoordSelStorage({ })
        }),
        CanProceed = () => SelectCoordinations.IsValidForSubmit(),
        HasActionableContent = () => SelectCoordinations.HasActionableContent();

    // Wire up some extra behaviors that go beyond what the SelectCoordinations component provides.
    PortCall.Schedule.map(sd => sd.CoordinationCards.map(ccard => {
        // Populate navigation properties for added C-Cards.
        ccard.ScheduleDate(sd);
        data.CoordinationCards.attach(ccard, [
            ccard.Coordination,
            ccard.Provider
        ]);

        // Remove the C-Card if it becomes obsolete (e.g. b/c of a change to the itinerary).
        S(() => {
            if (ccard.Coordination() && !ccard.Coordination()!.AppliesToScheduleDate(sd)) {
                sd.CoordinationCards.remove(ccard);
            }
        });
    }));

    return {
        ScheduleHeader,
        SelectCoordinations,
        CanProceed,
        HasActionableContent
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/coordinations.ts